var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("MEDICINES AND DRUGS")]),_c('h4',[_vm._v("Those for which a licensed medical practitioner has prescribed for dispensing, which are specifically required for the treatment of a covered Illness or Injury under this Agreement.")])])
}]

export { render, staticRenderFns }